export default __webpack_public_path__ + "static/media/logo-trustpilot-2-0-stars.d7769090.svg";